<template>

    <ui-view class="view-section-detail" v-spinner="loading">

        <ui-heading title="Vak detail" icon="magicon-tiles">
            <ui-button
                color="medium"
                type="bordered"
                @click="$router.go(-1)"
                slot="left">Terug</ui-button>
            <ui-button color="highlight-1" @click="exportExcel()">Exporteren</ui-button>
        </ui-heading>

        <pm-parcel-detail
            v-if="!loading"
            :parcel="section.parcel"
            :sections="[section]"
            :editable="$can('MUTATE_SECTIONS')"
            :deletable="$can('MUTATE_SECTIONS')"
            @delete="onActionDeleted"
            @cohort-close="onCohortClosed"/>

    </ui-view>

</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';

import createQuery from 'js-core/js/apollo/queries/createQuery';

import FindSectionQuery from 'gql/queries/SectionDetail/FindSection.gql';

import navigationMixin from 'app/mixins/navigation';
import ParcelDetail from 'app/components/ui/ParcelDetail.vue';

@Component({

    name: 'SectionDetail',
    mixins: [navigationMixin],
    components: {
        'pm-parcel-detail': ParcelDetail
    },
    apollo: {
        section: createQuery(FindSectionQuery, {

            skip() {

                return !this.sectionId;
            },

            variables() {

                return {
                    id: this.sectionId
                };
            }
        })
    }
})
export default class SectionDetail extends Vue
{
    loading = 0;
    section = null;

    breadcrumb(){

        return 'Vak detail';
    }

    onActionDeleted(){

        this.$refetchQuery('section');
    }

    onCohortClosed(){

        this.$refetchQuery('section');
    }

    exportExcel() {

        this.navigateExport('excel/section', {
            'sectionId': this.sectionId
        });
    }

    get sectionId() {

        return this.$route.params.id;
    }
}

</script>